import {SearchAppBar, SearchAppBarProps} from "~/apps/core/ui/SearchAppBar";
import {FiltersBar} from "~/apps/core/ui/FiltersBar";
import {AbsoluteContainer} from "~/apps/core/ui/AbsoluteContainer";
import {Box} from "@mui/material";
import React, {useCallback, useEffect, useMemo, useRef} from "react";
import {
    DateRangeChipInput,
    DateRangeChipInputProps, getOptions
} from "~/apps/packages/cargos/components/DateRangeChipInput";
import {useHistoryState} from "~/apps/core/utils";
import moment from "moment";
import {tuple} from "~/types";
import {StatusChipInput, StatusChipInputProps} from "~/apps/packages/cargos/components/StatusChipInput";
import {ShortCargo} from "~/apps/packages/cargos/queries";
import {CargoList} from "~/apps/packages/cargos/components/CargoList/CargoList";
import {useHistory} from "react-router-dom";
import {ToggleChipInput, ToggleChipInputProps} from "~/apps/core/ui/ChipInput/ToggleChipInput";


type FilterState = {
    archive?: boolean
    search?: string
    dateRange?: [Date, Date]
}

function useFilterState() {
    const [value, setValue, delValue] = useHistoryState<any>({
        name: "filter",
        serialize: state => JSON.stringify(state),
        deserialize: value => JSON.parse(value),
        handleBack: false,
    });

    const filter = useMemo(() => {
        const filter: FilterState = {};
        if (typeof value?.search == "string" && value.search.length > 0) {
            filter.search = value.search;
        }
        filter.archive = Boolean(value?.archive);
        if (Array.isArray(value?.dateRange) && value.dateRange.length == 2) {
            const dateRange = value.dateRange.map(x => moment(x));
            if (dateRange.filter(x => x.isValid()).length == 2) {
                filter.dateRange = dateRange.map(x => x.toDate());
            }
        }

        return filter;
    }, [value]);

    const setFilter = useCallback(async value => {
        if (value) {
            value = {...value};
            if (!value.search) {
                delete value.search;
            }
            if (!value.archive) {
                delete value.archive;
            }
            if (!value.dateRange) {
                delete value.dateRange;
            }
            if (Object.keys(value).length > 0) {
                await setValue(value);
                return;
            }
        }
        await delValue();
    }, []);

    return tuple(filter, setFilter);
}


export const IndexPage = () => {
    const history = useHistory();
    const $container = useRef<HTMLDivElement>();
    const [filter, setFilter] = useFilterState();
    const title = filter.search || "Грузы в порту";
    const filterDisabled = false;

    useEffect(() => {
        /// грязный хак для выставления дефолтного состояния фильтров. Если мы не вернулись назад то state == true
        if (!history.location.state) {
            history.replace({
                ...history.location,
                state: true,
            });
            setFilter({
                dateRange: getOptions().find(x => x.title == "Ближайшие")?.value
            }).then(() => null);
        }
    }, []);

    const handleSearchQueryChange: SearchAppBarProps["onSearch"] = (value) => {
        setFilter({
            ...filter,
            search: value,
        }).catch(console.error)
    }

    const handleDateRangeChange: DateRangeChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            dateRange: value,
        }).catch(console.error)
    }

    const handleArchiveChange: ToggleChipInputProps["onChange"] = (value) => {
        setFilter({
            ...filter,
            archive: value,
        }).catch(console.error)
    }

    return (
        <>
            <SearchAppBar
                position="fixed"
                color="default"
                title={title}
                disabled={filterDisabled}
                onSearch={handleSearchQueryChange}
                query={filter.search}
            >
                <FiltersBar>
                    <DateRangeChipInput disabled={filterDisabled} value={filter.dateRange}
                                        onChange={handleDateRangeChange}/>
                    <ToggleChipInput label="Архив" value={filter?.archive} onChange={handleArchiveChange}/>
                </FiltersBar>
            </SearchAppBar>

            <AbsoluteContainer disableGutters top={104} ref={$container}>
                <CargoList query={filter.search}
                           statuses={filter?.archive ? ["Убыл", "Расформирован"] : ["В порту", "Ожидается"]}
                           dateFrom={filter?.dateRange ? filter.dateRange[0] : null}
                           dateTo={filter?.dateRange ? filter.dateRange[1] : null}/>
                <Box minHeight="16px" />
            </AbsoluteContainer>
        </>
    )
}